import { render, staticRenderFns } from "./VendorsMap.vue?vue&type=template&id=3185e700&scoped=true&"
import script from "./VendorsMap.vue?vue&type=script&lang=js&"
export * from "./VendorsMap.vue?vue&type=script&lang=js&"
import style0 from "./VendorsMap.vue?vue&type=style&index=0&id=3185e700&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3185e700",
  null
  
)

export default component.exports